import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["yandexAuth"];
import stages from '../stages';

var openCenteredWindow = function openCenteredWindow(_ref) {
  var url = _ref.url,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height;
  var left = screen.width / 2 - width / 2;
  var top = screen.height / 2 - height / 2;
  window.open(url, title, "width=".concat(width, ",height=").concat(height, ",top=").concat(top, ",left=").concat(left));
};
/**
 * @typedef {Object} OAuthYandexResponseDto
 * @property {string} access_token
 * @property {string} token_type
 * @property {number} expires_in
 * @property {string} [refresh_token]
 * @property {string} [scope]
 */

/**
 * @param {string} stage
 * @param {function(OAuthYandexResponseDto): void} callback
 */


export default (function (stage, callback) {
  if (window.S7yandex) {
    var _window$S7yandex = window.S7yandex,
        apiId = _window$S7yandex.apiId,
        domain = _window$S7yandex.domain,
        pathAuth = _window$S7yandex.path.auth,
        setMessage = _window$S7yandex.setMessage;
    var redirect = "".concat(stages(stage), "/yandex");
    var encodedRedirectUrl = encodeURIComponent(redirect);
    var encodedDomain = encodeURIComponent(domain);
    var encodedPath = encodeURIComponent(pathAuth);
    /**
     * Обязательные к передаче query-параметры:
     * - redirectUrl - url перенаправления после прохождения авторизации.
     * Требуется передавать, так как различается для различных стендов.
     * - apiId - client_id
     * - domain - url приложения identity-провайдера
     * - path - часть url приложения identity-провайдера, определяющая страницу
     * */

    var authUrl = "".concat(stages(stage), "/yandex/redirect?redirectUrl=").concat(encodedRedirectUrl, "&apiId=").concat(apiId, "&domain=").concat(encodedDomain, "&path=").concat(encodedPath);
    /**
     * Производит GET-запрос к прокси, которая производит дальнейший редирект.
     * */

    openCenteredWindow({
      url: authUrl,
      title: 'Yandex ID',
      width: 520,
      height: 840
    });

    if (!setMessage) {
      window.addEventListener('message', function handleMessage(event) {
        if (redirect.indexOf(event.origin) >= 0) {
          var data = {};

          try {
            data = JSON.parse(event.data);
          } catch (error) {// do nothing
          }

          var _ref2 = data || {},
              yandexAuth = _ref2.yandexAuth,
              response = _objectWithoutProperties(_ref2, _excluded);

          if (yandexAuth && !response.error) {
            callback(response);
          }

          setTimeout(function () {
            var _event$source;

            if (event !== null && event !== void 0 && (_event$source = event.source) !== null && _event$source !== void 0 && _event$source.close) {
              event.source.close();
            }
          }, 100);
        }
      });
      window.S7yandex.setMessage = true;
    }
  }
});